module.exports = __webpack_public_path__ + "static/media/statisticsIndexTitle.ca865fec.png";